<template>
  <div class="p-detail" v-loading="loading">
    <div class="g-header">
      <el-page-header
        @back="$router.go(-1)"
        :content="`${headerInfo.label}详情`"
        :class="headerInfo.color && 'white-txt'"
        :style="{
          background: headerInfo.color
        }"
      >
        <div slot="title">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </el-page-header>
    </div>
    <div class="split-top scroll-body">
      <div class="revertInfo">
        <message :info="revertInfo" :show-tags="false" :hide-btns="['at', 'reply', 'expand']" @click-btn="messageClickHandle"></message>
      </div>
      <p class="reply-tip" v-if="totalCount">共{{ totalCount }}条回复</p>
      <div class="no-reply" v-else-if="loading === false">
        <img src="@/assets/images/message.png" alt="" />
        暂无回复
      </div>
      <ul ref="messageList" v-if="messageList.length">
        <li ref="message" v-for="(item, index) in messageList" :key="index">
          <message
            :types="types"
            :show-tags="false"
            :info="item"
            :hide-btns="['reply', 'expand']"
            :reward-info="revertInfo.msgType === 4 ? revertInfo : null"
            @click-btn="messageClickHandle"
          ></message>
        </li>
      </ul>
      <el-divider v-if="totalCount && totalCount <= this.messageList.length">暂无更多回复</el-divider>
    </div>

    <div class="g-footer">
      <edit-box :reply="reply" :ats.sync="ats" :types="[]" @send="sendMessage"></edit-box>
    </div>
  </div>
</template>
<script>
import Message from "@/components/Message";
import EditBox from "@/components/EditBox";
import Chat from "@/api/chat";
import Bus from "@/components/Bus";
import Types from "@/components/tags";
import Utils from "@/utils";
export default {
  components: { Message, EditBox },
  data() {
    return {
      ats: [],
      id: "",
      loading: true,
      pageSize: 20,
      pageIndex: 0,
      totalCount: 0,
      reply: { id: "", txt: "" },
      revertInfo: {},
      types: Types,
      messageList: [],
      msgIdList: []
    };
  },
  computed: {
    headerInfo() {
      let info = { color: "", label: this.revertInfo.tags };
      const index = this.types.findIndex(item => item.label === this.revertInfo.tags);
      if (index !== -1) {
        info = this.types[index];
      }
      return info;
    },
    token() {
      return this.$store.state.token;
    }
  },
  watch: {
    token: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          const { id } = this.$route.query;
          this.id = id;
          await this.getDetail(id);
          this.loading = false;
          this.getDetailList();
        }
      }
    }
  },
  methods: {
    scrollHandle() {
      if (Utils.inBottom() && !this.loading) {
        if (this.messageList.length < this.totalCount) {
          this.pageIndex += 1;
          this.getDetailList(this.id);
        }
      }
    },
    more() {
      this.pageIndex += 1;
      this.getDetailList();
    },
    sendMessage(message) {
      message.reply = this.revertInfo.msgId;
      Bus.$emit("sendMessage", message);
    },
    messageClickHandle(e) {
      if (e.type === "at") {
        const findItem = this.ats.find(item => item.id === e.info.id);
        !findItem && this.ats.unshift({ id: e.info.id, name: e.info.name });
      }
      if (e.type === "reply") {
        this.reply = {
          id: e.info.msgId,
          txt: e.info.txt
        };
      }
    },
    async getDetail(id) {
      this.revertInfo = await Chat.detail(id).then(res => {
        res.time = this.$timeFormat(res.t);
        this.reply = {
          id: res.msgId,
          txt: res.txt
        };
        return res;
      });
    },
    async getDetailList({ id = this.id, pageIndex = this.pageIndex } = {}) {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const messageList = await Chat.detailList({
        id,
        pageIndex,
        msgType: this.revertInfo.msgType
      })
        .then(res => {
          this.totalCount = res.TotalCount;
          res.ResultList.map(item => {
            item.time = this.$timeFormat(item.t);
          });
          return res.ResultList;
        })
        .catch(() => (this.loading = false));
      messageList &&
        messageList.map(item => {
          if (!this.msgIdList.includes(item.msgId)) {
            this.messageList.push(item);
            this.msgIdList.push(item.msgId);
          }
        });
      this.$nextTick(() => (this.loading = false));
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle, true);
    Bus.$off("broadcast");
  },
  async created() {
    window.addEventListener("scroll", this.scrollHandle, true);
    Bus.$on("broadcast", message => {
      if (message.reply === this.id) {
        this.pageIndex = 1;
        this.getDetailList({ force: true });
        window.scrollTo(0, 0);
      }
    });
  }
};
</script>
<style lang="scss">
.p-detail {
  .el-page-header {
    color: #fff;
    .el-page-header__content {
      font-size: 14px;
    }
  }
  .reply-tip {
    padding: 8px 12px;
    font-size: 12px;
    color: #666;
  }
  .no-reply {
    padding-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 130px;
    }
  }
  .el-divider {
    margin: 10px 0px 10px 0px !important;
  }
  .white-txt {
    .el-page-header__content,
    .el-page-header__left {
      color: #fff !important;
    }
  }
  .scroll-body {
    padding-top: 32px;
    padding-bottom: 80px;
    position: relative;
    height: 100%;
    overflow: auto;
  }
  .revertInfo {
    background-color: #f5f5f5;
    border-bottom: 1px solid #dbdbdb;
    .m-message {
      padding: 0 10px;
    }
  }
  ul {
    li {
      border-bottom: 1px solid #eee;
    }
    .m-message {
      padding: 0 10px;
    }
    li:last-child {
      border-bottom: none;
    }
  }
}
</style>
atc
